import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "auth complete-new-password" }
const _hoisted_2 = { class: "form-group row" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "New Password", -1)
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("small", {
  id: "password-help",
  class: "form-text text-muted"
}, " Min. 8 chars with at least 1 uppercase letter, lowercase letter and digit. ", -1)
const _hoisted_6 = { class: "form-group row" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "col-sm-3 col-form-label" }, "Confirm Password", -1)
const _hoisted_8 = { class: "col-sm-6" }
const _hoisted_9 = {
  key: 0,
  id: "password-confirm-help",
  class: "form-text text-muted"
}
const _hoisted_10 = {
  key: 0,
  class: "text-success"
}
const _hoisted_11 = {
  key: 1,
  class: "text-danger"
}
const _hoisted_12 = { class: "form-group row" }
const _hoisted_13 = { class: "col-sm-6 offset-sm-3" }
const _hoisted_14 = ["disabled"]

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import Auth from '@aws-amplify/auth';
import { useToast } from "vue-toastification";


export default /*#__PURE__*/_defineComponent({
  __name: 'CompleteNewPassword',
  setup(__props) {

const store = useStore();
const router = useRouter();
const toasted = useToast();

const cognitoUser = computed(() => store.getters['auth/cognitoUser']);
const password = ref('');
const passwordConfirm = ref('');

const updatePassword = async () => {
  try {
    await Auth.completeNewPassword(cognitoUser.value, password.value, {});
    router.push({ name: 'reports' });
  } catch (err: any) {
    toasted.error(err.message);
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event))
        }, null, 512), [
          [_vModelText, password.value]
        ]),
        _hoisted_5
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("div", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          class: "form-control",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((passwordConfirm).value = $event))
        }, null, 512), [
          [_vModelText, passwordConfirm.value]
        ]),
        (passwordConfirm.value.length)
          ? (_openBlock(), _createElementBlock("small", _hoisted_9, [
              (password.value === passwordConfirm.value)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Passwords match"))
                : (_openBlock(), _createElementBlock("span", _hoisted_11, "Passwords DO NOT match"))
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (updatePassword())),
          disabled: (password.value.length < 8 || password.value !== passwordConfirm.value)
        }, " Update my password ", 8, _hoisted_14)
      ])
    ])
  ]))
}
}

})